import {
  deselectGifteeBoxTemplate,
  selectGifteeBoxTemplate
} from '@console/actions/actions';
import type { AppThunkDispatch } from '@console/actions/thunkType';
import DisplaySelectedGifteeBoxConfigForGCPProject from '@console/components/project/gifteeBoxConfigs/exchangeReport/DisplaySelectedGifteeBoxConfigForGCPProject';
import type { AppState } from '@console/reducers';
import type { LocalGifteeBoxConfig } from '@console/reducers/projects';
import { getSelectedGifteeBoxConfig } from '@console/selectors/projectDetail/gifteeBoxConfigs';
import { getSelectedApiGifteeBoxIssueConfigExchangeableEndLabel } from '@console/selectors/projectDetail/gifteeBoxConfigs/apiGifteeBoxConfigs';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  selectedGifteeBoxConfig: getSelectedGifteeBoxConfig(state),
  exchangeableEndLabel:
    getSelectedApiGifteeBoxIssueConfigExchangeableEndLabel(state)
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  selectGifteeBoxTemplate: (
    gifteeBoxTemplate: LocalGifteeBoxConfig['gifteeBoxTemplate']
  ) => dispatch(selectGifteeBoxTemplate(gifteeBoxTemplate)),
  deselectGifteeBoxTemplate: () => dispatch(deselectGifteeBoxTemplate())
});

export type DisplaySelectedGifteeBoxConfigForGCPProjectMappedFromState =
  ReturnType<typeof mapStateToProps>;

export type DisplaySelectedGifteeBoxConfigForGCPProjectMappedFromDispatch =
  ReturnType<typeof mapDispatchToProps>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisplaySelectedGifteeBoxConfigForGCPProject);
